var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list"},[_c('table',{staticStyle:{"padding-top":"5px"}},[_c('tbody',_vm._l((_vm.participants),function(user){return _c('tr',{key:user.id},[_c('td',{staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"img-msg",attrs:{"src":user.imageUrl}})]),_vm._v(" "),_c('td',{staticClass:"user-element"},[_vm._v(_vm._s(user.name))])])}),0)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c15eddc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2/popup-chat/UserList.vue
// module id = kPxI
// module chunks = 0